/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  LIST_CATEGORIES,
  useCategoryListFilter,
  useCategoryListOrder,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InfiniteDataGrid } from '../infiniteDataGrid';
import { CategoryTableData, useColumns } from './useColumns';

export type CategoryListProps = {
  maxHeight?: number;
  paddingBottom?: number;
  preserveScrollKey?: string;
  assetButton?: (data: CategoryTableData) => JSX.Element;
  peopleButton?: (data: CategoryTableData) => JSX.Element;
  editCategoryMenu: (label: any) => JSX.Element;
};

export const CategorysList = ({
  maxHeight,
  paddingBottom,
  preserveScrollKey,
  assetButton,
  peopleButton,
  editCategoryMenu,
}: CategoryListProps) => {
  const { t } = useTranslation();

  const AssetButton = assetButton;
  const PeopleButton = peopleButton;
  const EditCategoryMenu = editCategoryMenu;

  const { data } = useCategoryListFilter();
  const { data: orderData } = useCategoryListOrder();
  const workspace = useCurrentWorkspace(true);

  const [filter, setFilter] = useState<any>(undefined);
  const [categoriesSelected, setCategorysSelected] = useState<
    string[] | undefined
  >(undefined);

  const showCategoryMenu = useMemo(() => {
    return categoriesSelected?.length === 1 ? true : false;
  }, [categoriesSelected]);

  const updateCategorySelection = (rows: any) => {
    setCategorysSelected(rows.map((row: any) => row.id));
  };

  useEffect(() => {
    if (!data || workspace === undefined) return;
    const f = { ...data };
    f.workspaceId = workspace?.id;
    if (f.keyword === '') delete f.keyword;
    setFilter(f);
  }, [data, workspace]);

  const columns = useColumns(filter, AssetButton, PeopleButton) as ColumnDef<
    any,
    any
  >[];

  const RenderEditCategoryMenu = () =>
    showCategoryMenu && categoriesSelected ? (
      <EditCategoryMenu
        categoryId={categoriesSelected[0]}
        label={t('categories.menu.editCategory')}
      />
    ) : (
      <></>
    );

  return !filter ? null : (
    <InfiniteDataGrid
      modelName="category"
      query={LIST_CATEGORIES}
      orderBy={orderData}
      filter={filter}
      pageSize={50}
      columns={columns}
      listMaxHeight={maxHeight as number}
      paddingBottom={paddingBottom as number}
      textEmpty={t('categories.common.textEmpty')}
      dataPrefix="category.listCategorys"
      enableScrollRefresh={true}
      preserveScrollKey={preserveScrollKey}
      showScrollIndicator={true}
      exportFileName="categories"
      updateRowsSelected={(rows) => updateCategorySelection(rows)}
      headerContent={RenderEditCategoryMenu()}
    />
  );
};
